import { useContext } from 'react';
import '../styles/basic.css';
import { MagicCursor } from './MagicCursor';
import CursorProvider, { CursorContext, CursorState } from '../providers/CursorProvider';
import { ASCII } from './ASCII';
import webmaster from 'url:../assets/ascii/webmaster.txt';
import { ChatBubble } from './ChatBubble';
import { useNavigate } from 'react-router';

export function Main() {
    const context = useContext<CursorContext>(CursorProvider.context);
    const nav = useNavigate();

    return <div className='main-body'>
        <ASCII id={'wlair-webmaster'} ascii={webmaster} size={12} />
        
        <br />

        <div className='v-box gap-8'>
            <ChatBubble text={"Hello friends! I'm the Webmaster!"} />
            <ChatBubble text={"Plz help!!"} />
            <ChatBubble text={"There's a bunch of important files stuck in my brain but I can't remember them..."} />
            <ChatBubble text={"Can you find and open the Archive?"} />
        </div>

        <button onClick={() => { nav('/tripleoaks') }}>Enter my Brain</button>
    </div>;
}